module.exports = __webpack_public_path__ + "static/img/rhino-4.30d98ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/benches/rhino-4.jpg
// module id = 546
// module chunks = 0